import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getBomLibraryGroup = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_GROUP.GET}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSeasons = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_GROUP.GET_SEASONS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCategory = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_GROUP.CATEGORY}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomLibraryGroupById = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_GROUP.GET_BY_ID}${params.groupId}`, {
      params: { ...params },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getCategoryType3 = async (datas) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_GROUP.CATEGORY}`, {
      params: { ...datas },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addNewBomLibraryGroup = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.BOM_LIBRARY_GROUP.CREATE}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateBomLibraryGroup = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.BOM_LIBRARY_GROUP.UPDATE}${data.groupId}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteBomLibraryGroup = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.BOM_LIBRARY_GROUP.DELETE}`, {
      data: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveSequence = async (id, data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.BOM_LIBRARY_GROUP.SAVE_SEQUENCE}/${id}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getBomLibraryGroupOptions = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.BOM_LIBRARY_GROUP.GET_OPTIONS}`, {
      params: data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
